export const FETCH_TAG_SUGGESTIONS_REQUEST = 'FETCH_TAG_SUGGESTIONS_REQUEST';
export const FETCH_TAG_SUGGESTIONS_SUCCESS = 'FETCH_TAG_SUGGESTIONS_SUCCESS';
export const FETCH_TAG_SUGGESTIONS_FAILURE = 'FETCH_TAG_SUGGESTIONS_FAILURE';

//fetch inventory by category
export const INVENTORY_REQUEST = 'INVENTORY_BY_CATEGORY_REQUEST';
export const INVENTORY_SUCCESS = 'INVENTORY_BY_CATEGORY_SUCCESS';
export const INVENTORY_FAIL = 'INVENTORY_BY_CATEGORY_FAIL';

//Order send to manufacturer
export const ORDER_SUBMIT_REQUEST = 'ORDER_SUBMIT_REQUEST';
export const ORDER_SUBMIT_SUCCESS = 'ORDER_SUBMIT_SUCCESS';
export const ORDER_SUBMIT_FAIL = 'ORDER_SUBMIT_FAIL';


//inventory fabric constant
export const INVENTORY_FABRICS_REQUEST = 'INVENTORY_FABRICS_REQUEST';
export const INVENTORY_FABRICS_SUCCESS = 'INVENTORY_FABRICS_SUCCESS';
export const INVENTORY_FABRICS_FAIL = 'INVENTORY_FABRICS_FAIL';

//inventory lift style constant
export const INVENTORY_LIFTSTYLE_REQUEST = "INVENTORY_LIFTSTYLE_REQUEST";
export const INVENTORY_LIFTSTYLE_SUCCESS = "INVENTORY_LIFTSTYLE_SUCCESS";
export const INVENTORY_LIFTSTYLE_FAIL = "INVENTORY_LIFTSTYLE_FAIL";

//matrix constant for order create
export const DEALER_MATRIX_REQUEST = "DEALER_MATRIX_REQUEST";
export const DEALER_MATRIX_SUCCESS = "DEALER_MATRIX_SUCCESS";
export const DEALER_MATRIX_FAIL = "DEALER_MATRIX_FAIL";

//product Constant
export const PRODUCT_TYPES_REQUEST = 'PRODUCT_TYPES_REQUEST';
export const PRODUCT_TYPES_SUCCESS = 'PRODUCT_TYPES_SUCCESS';
export const PRODUCT_TYPES_FAIL = 'PRODUCT_TYPES_FAIL';